<div>
  <!------------------------------------------ Back ------------------------------------>
  <div
    class="absolute w-[40px] h-[37px] bg-white shadow-lg rounded-full flex justify-center items-center m-2 z-[99]"
    style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)"
    (click)="goback()"
  >
    <img
      src="icons/Payment/back-payment.png"
      alt="back"
      class="w-[30px] h-[30px]"
    />
  </div>
  <div class="flex justify-center items-center w-full bg-yellow-300 shadow-lg py-4">
    <p class="text-[24px] font-[650] text-[#5E5D5D]">
      {{ currentLang === "TH" ? "รายการชำระเงิน" : "Top up history" }}
    </p>
  </div>
  <!------------------------------------------- Content ------------------------------------->
  <div
    class="flex flex-col justify-center items-center w-full overflow-y-scroll space-y-2 py-3 animation-slide-up"
  >
    <span class="text-gray-400 font-medium text-sm">{{
      currentLang === "TH" ? "ดูย้อนหลัง 30 วัน" : "View last 30 days"
    }}</span>
    <div
      class="w-full border-b border-gray-300 shadow"

      *ngFor="let history of dataHistory"
    >
      <div
        class="w-full bg-white flex justify-between items-center p-2 "
      >
        <div class="flex-1">
          <p class="text-[#f7c92c] font-[650]">{{ history.siteName }}</p>
          <p class="text-[#5E5D5D] text-[14px]">
            {{ currentLang === "TH" ? "ไอดีชำระเงิน : " : "Top up ID : " }}
            {{ history.transactionNo }}
          </p>
          <p class="text-[#5E5D5D] text-[14px]">
            {{ currentLang === "TH" ? "ผู้ชำระเงิน : " : "User payment : " }}
            {{ history.cpuName }}
          </p>
          <!-- <p class="text-[#5E5D5D] text-[14px]">
            {{ currentLang === "TH" ? "เวลาชำระเงิน : " : "Time payment : " }}
            {{ history.cpuName }}
          </p> -->
          <!-- <p class="text-[#5E5D5D] text-[14px]">
            {{ currentLang === "TH" ? "ถึง : " : "Receive : " }}
            นาย ผู้รับ นามสกุล
          </p> -->
        </div>
        <div class="w-[140px]">
          <p
            class="bg-[#FFD700] text-[14px] rounded-full w-full p-1 flex justify-center items-center text-[#5E5D5D]"
          >
            {{ history.paidDate | date : "dd/MM/yyyy HH:mm" }}
          </p>
          
        </div>
      </div>
      <div class="w-full px-2">
        <hr class="border-b border-gray-200 "  />
      </div>
      <div class="bg-white mt-1 px-2 py-1 flex justify-between items-center">
        <div>
          <p>{{ currentLang === "TH" ? "รายการ : " : "Description : " }}</p>
          <p class="text-[14px] text-[#5E5D5D]">{{ history.feeName }}</p>
        </div>
        <div class="text-right">
          <p>{{ currentLang === "TH" ? "ราคา" : "Price" }}</p>
          <p class="font-bold text-red-400">
            {{ history.topupMethod === "Payment" ? "-" : "" }}
              {{ history.amount }} {{ currentLang === "TH" ? "บาท" : "Baht" }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!---------------------------------------- Loading ------------------------------------>
<app-pss-loading *ngIf="isLoading"></app-pss-loading>
